module.exports = require("ngx-bootstrap/collapse");